import { createFileRoute } from '@tanstack/react-router';

import { ReviewBrowse } from '@/module/Author/Review';

export const Route = createFileRoute('/_auth/author/_author/review/_review/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <ReviewBrowse />;
}
